export const qaEnvsUSA = ['qa1', 'qa2', 'fgp1', 'fgp2'];

export const PRODUCT = {
  CASINO: 'casino',
} as const;

export const UNIFIED_MODULES_BRANDS = {
  MOHEGANSUN: 'MoheganSun',
  FANDUEL: 'FanDuel',
} as const;

export const BRAND = {
  FANDUEL: 'fanduel',
  MOHEGANSUN: 'mohegansun',
} as const;

export const ENVIRONMENT = {
  CERT: 'cert',
  PROD: 'prod',
  QA: 'qa',
} as const;

export const COUNTRY_ABBREVIATION = {
  USA: 'us',
  CANADA: 'ca',
} as const;

export const COUNTRY = {
  USA: 'usa',
  CANADA: 'canada',
} as const;
